if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if(this.form){
          const idInput = this.form.querySelector("[name=id]");
          if (idInput) idInput.disabled = false;
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer") && this.submitButton)
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        this.ensurePinnedMediaVisibility = this.ensurePinnedMediaVisibility.bind(this);

        this.addEventListener("change", () => {
          requestAnimationFrame(this.ensurePinnedMediaVisibility);
        });
      }

      fnv32a(str, is64 = false) {
        let FNV1_32A_INIT = 0x811c9dc5;
        let hval = FNV1_32A_INIT;
        for (var i = 0; i < str.length; ++i) {
          hval ^= str.charCodeAt(i);
          hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
        }
        const result = ("0000000" + (hval >>> 0).toString(16)).substr(-8);
        if (!is64) return this.fnv32a(result + str + Math.random(0, 1000), true);
        return result;
      }

      getVariantData(variantId, productId) {
        const resolvedProductId = productId || this.submitButton?.dataset.productId;
        const variantJsonElement = resolvedProductId
          ? `[type="application/json"]#variants, [type="application/json"]#variants-${resolvedProductId}`
          : `[type="application/json"]#variants`;
        const metafieldJsonElement = resolvedProductId
          ? `[type="application/json"]#metafields, [type="application/json"]#metafields-${resolvedProductId}`
          : `[type="application/json"]#metafields`;

        const localScope =
          this.closest(".products-recommended__informations") ||
          this.closest(".products-recommended-list__actions") ||
          this;

        const variantJsonNode =
          document.querySelector(variantJsonElement) ||
          localScope.querySelector('[type="application/json"][id^="variants-"]');

        if (!variantJsonNode) {
          return null;
        }

        const parsedVariants = JSON.parse(variantJsonNode.textContent || "[]");
        let variantData = Array.isArray(parsedVariants) ? parsedVariants : parsedVariants.variants || [];

        let variantMetafields = document.querySelector(metafieldJsonElement)
          ? JSON.parse(document.querySelector(metafieldJsonElement).textContent)
          : null;
        if(variantMetafields && variantMetafields.length > 0) {
          variantMetafields.forEach((metafield) => {
            const index = variantData.findIndex((variant) => {
              return parseInt(variant.id) === parseInt(metafield.variant_id)
            })
            if(index > -1) {
              variantData[index].metafield = metafield;
            }
          });
        } 
        const variant = variantData.find((v) => parseInt(v.id) === parseInt(variantId));

        if (!variant) {
          return null;
        }
      
        const result = {
          metafield: variant.metafield || null,
          selling_plan_id: variant.selling_plan_allocations?.[0]?.selling_plan_id || null
        };

        return result;
      }

      ensurePinnedMediaVisibility() {
        try {
          const galleries = document.querySelectorAll("media-gallery");
      
          galleries.forEach((gallery) => {
            const list = gallery.querySelector('ul[id^="Slider-Gallery-"]');
            if (!list) return;
      
            const pinned = Array.from(list.querySelectorAll('li[data-media-id*="-pinned-"]'));
            if (pinned.length === 0) return;
      
            pinned.forEach((li) => {
              if (li.style && li.style.display === "none") li.style.display = "";
              li.removeAttribute("hidden");
              li.setAttribute("aria-hidden", "false");
            });
      
            pinned.sort((a, b) => {
              const aId = a.getAttribute("data-media-id") || "";
              const bId = b.getAttribute("data-media-id") || "";
              const aMatch = aId.match(/-pinned-(\d+)/);
              const bMatch = bId.match(/-pinned-(\d+)/);
              const aIdx = aMatch ? parseInt(aMatch[1], 10) : 0;
              const bIdx = bMatch ? parseInt(bMatch[1], 10) : 0;
              return aIdx - bIdx;
            });
      
            const frag = document.createDocumentFragment();
            pinned.forEach((li) => frag.appendChild(li));
            list.insertBefore(frag, list.firstChild);

            const visiblePinned = pinned.filter((li) => li.offsetParent !== null);
            if (visiblePinned.length === 0) return;

            const slides = Array.from(list.querySelectorAll('li.slider__slide'));
            slides.forEach((li) => li.classList.remove('is-active'));
            visiblePinned[0].classList.add('is-active');

            const prevScrollBehavior = list.style.scrollBehavior;
            list.style.scrollBehavior = 'auto';
            list.scrollLeft = 0;

            requestAnimationFrame(() => {
              list.style.scrollBehavior = prevScrollBehavior;
            });
          });
        } catch (e) {}
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        const sizeInput = this.parentElement.parentElement.querySelectorAll('variant-radios input[name="Tamanho"]');
        if (sizeInput && sizeInput.length > 0) {
          const sizeSelected = Array.from(sizeInput).find((input) => input.checked);
          if (!sizeSelected) {
            this.handleErrorMessage("Escolha seu tamanho!");
            const productButtons = document.querySelector('.Product__InfoWrapper');
            if (productButtons) {
              productButtons.scrollIntoView({ behavior: 'smooth', block: 'start' });
              setTimeout(() => {
                window.scrollBy(0, -100);
              }, 1000);
            }
            return;
          }
        }
        this.handleErrorMessage();

        if (this.submitButton) {
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.classList.add("loading");
        }
        const spinner = this.querySelector(".loading-overlay__spinner");
        if (spinner) spinner.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        // Mecânicas agrupadas adicionadas pelo product-form precisam de uma
        // identidade por ocorrência para a Shopify não consolidar duas
        // adições iguais na mesma cart line. Progressive discount fica fora:
        // ele deve continuar acumulando quantidade para subir de tier.
        const groupedPromoSources = new Set([
          "buy_and_save",
          "buy-and-save",
          "buy-x-pay-y",
        ]);
        const promoSource = String(
          formData.get("properties[__productSource]") || "",
        ).trim();

        if (groupedPromoSources.has(promoSource)) {
          const promoInstanceId =
            window.crypto && typeof window.crypto.randomUUID === "function"
              ? window.crypto.randomUUID()
              : `promo-${Date.now()}-${Math.random().toString(36).slice(2)}`;
          formData.set("properties[__promoInstanceId]", promoInstanceId);
        }
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          // formData.append("properties[_key]", this.fnv32a(new Date().getTime().toString() + Math.random(0, 1000)));

          const _variantData = this.getVariantData(formData.get("id"), formData.get("product-id"))
          const [metafieldData, sellingPlanData] = _variantData ? Object.entries(_variantData) : [[], []];
          if(metafieldData[1] && sellingPlanData[1]) {
            formData.append(`properties[${metafieldData[1].pre_order.key}]`, metafieldData[1].pre_order.value);
            formData.append(`selling_plan`, sellingPlanData[1]);
          }

          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        config.headers["site-placement"] = this.dataset.placement || "product-form";
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              if (this.submitButton) {
                const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
              }
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form", productVariantId: formData.get("id") });
              fetchCartAndDispatch('product-form', 'add');
            }
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal"); // TODO: Implementar novo quick-add
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner")?.classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
